import { render } from "./appEduEvaLesson.vue?vue&type=template&id=5a87c6ae&scoped=true"
import script from "./appEduEvaLesson.vue?vue&type=script&lang=js"
export * from "./appEduEvaLesson.vue?vue&type=script&lang=js"

import "./appEduEvaLesson.vue?vue&type=style&index=0&id=5a87c6ae&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a87c6ae"]])

export default __exports__